<template>
  <div class="wrap wrap-tec">
    <div class="cover">
      <img src="@/assets/img/products/recombinant-cells-protein-expression/cover.png" class="img-fluid" alt="">
    </div>
    <div class="content">
      <p class="desc mt20">
        从基因到蛋白到重组抗体表达一站式服务平台，满足越来越多的研究者对于快速、高通量蛋白或抗体研究的需求。尤其随着近几年抗体药物的快速发展，为了适应市场的变化，推出快速重组抗体表达服务，通过高通量瞬转抗体表达技术平台，实现重组抗体快至一周交付。
      </p>
      <div class="c-title">服务类型<small class="mt20">Service type</small></div>
      <div class="title-text mt50">快速重组抗体表达：</div>
      <table class="table mt20">
        <tr>
          <th>项目内容</th>
          <th>表达系统</th>
          <th>服务编号</th>
          <th>体系</th>
          <th>周期</th>
          <th>价格</th>
        </tr>
        <tr v-for="subList in firstTableData" :key="subList[0].content">
          <td v-for="{ content, span } in subList" :key="content" :rowspan="span">{{ content }}</td>
        </tr>
      </table>
      <div class="title-text mt50">重组蛋白表达：</div>
      <table class="table mt20">
        <tr>
          <th>服务名称</th>
          <th>服务编号</th>
          <th>服务内容</th>
          <th>周期</th>
        </tr>
        <tr v-for="(subList, index) in secondTableData" :key="subList[0].content + index">
          <td v-for="{ content, span } in subList" :key="content" :rowspan="span || 1">{{ content }}</td>
        </tr>
      </table>
      <table class="table left-align-table mt100">
        <tr>
          <th>表达系统</th>
          <th>优点</th>
          <th>缺点</th>
          <th>应用领域</th>
        </tr>
        <tr v-for="subList in thirdTableData" :key="subList[0].content">
          <td v-for="({ content, span }, i) in subList" width="25%" :class="[[1, 2].includes(i) ? 'align-left' : '']"
            :key="content" :rowspan="span || 1">{{ content }}</td>
        </tr>
      </table>
    </div>
    <div class="service mt100">
      <div class="c-title">服务优势<small class="mt20">Service advantage</small></div>
      <div class="content">
        <img src="@/assets/img/products/recombinant-cells-protein-expression/advantage.png" alt="">
        <div class="content-text">
          <span>周期快：一站式表达服务平台，从设计合成到表达纯化，实现无缝衔接，为客户较大程度的缩短研发周期；</span>
          <span>表达量高：改造的载体和筛选的高表达菌株，完善的流程体系，整体上提高蛋白和抗体表达量；</span>
          <span>通量高：针对重组抗体表达服务，通量高达800条/次；</span>
          <span>高交付率：成熟团队，经验丰富，交付率高。</span>
        </div>
      </div>
    </div>
    <qk-consult type="orderForm" />
  </div>
</template>

<script>
import { firstTableData, secondTableData, thirdTableData } from './constants'
export default {
  name: 'RecombinantCellsProteinExpression',
  data() {
    this.firstTableData = firstTableData
    this.secondTableData = secondTableData
    this.thirdTableData = thirdTableData
    return {}
  }
}
</script>

<style lang="scss" scoped>
.desc {
  font-size: 16px;
}

.mt100 {
  margin-top: 100px;
}

.left-align-table {
  white-space: pre-line;

  .align-left {
    padding-left: 15px;
    text-align: left;
  }
}

.content {
  padding: 0 18.5vw;

  .title-text {
    font-weight: 500;
    font-size: 20px;
  }
}


.service {
  background: #F7FBFE;
  padding-bottom: 60px;

  .c-title {
    padding: 60px 0;
  }

  .content {
    display: flex;
    img{
      width: 100%;
    }
    &-text {
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
}

@media screen and (max-width: 640px) {
  .table th {
    padding: 10px;
  }

  .content {
    padding: 0 10vw;
  }

  .service {
    .content {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/products/recombinant-cells-protein-expression/index.vue